export default {
  server: {
    baseUrl: "https://jkchrome.com/api/v2",
  },
};
